export default __webpack_public_path__ + "static/media/404@2x.75aee817.png";